import { render, staticRenderFns } from "./upgrades.vue?vue&type=template&id=337146da"
import script from "./upgrades.vue?vue&type=script&lang=js"
export * from "./upgrades.vue?vue&type=script&lang=js"
import style0 from "./upgrades.vue?vue&type=style&index=0&id=337146da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports